export default __webpack_public_path__ + "static/media/Chat-new 1.da4553b3.svg";